import { setDateWithTimezone as e, toISOStringWithoutTimezone as t } from "../utils/date-utils.js";
import { useEffect as n, useMemo as r, useState as i } from "react";
//#region src/date-picker/date-time-picker/use-date-time.ts
function a({ value: a, timezone: o, onChange: s }) {
	let c = r(() => a ? e(a, o) : null, [a, o]), [l, u] = i(c), [d, f] = i(c);
	return n(() => {
		u(c), f(c);
	}, [c]), {
		appliedDate: d,
		applyDateTime: (e) => {
			if (!e) {
				u(null), f(null), s(null);
				return;
			}
			let n = new Date(e);
			u(n), f(n), s(t(n));
		},
		selectedDate: l,
		setSelectedDate: u
	};
}
//#endregion
export { a as useDateTime };
